import React, { useEffect, useState } from 'react';

import Spinner from '../Spinner';
import {
  AutocompleteSuggestionType,
  fetchSuggestions,
  handleSelectSuggestion,
  handleTypedAdress,
} from './AddressSearchAutocomplete.service';
import { BLACK } from 'src/constants';
import Input from '../Input';

type AddressSearchAutocompleteInputProps = {
  typedAddress: string;
  setTypedAddress: React.Dispatch<React.SetStateAction<string>>;
  handleAddressSelection: (
    selectedAddressValue: any,
    placeId: string
  ) => Promise<void>;
  handleAddressInputFormControlError: (
    status: any,
    clearSuggestions: any
  ) => void;
  hasErrorAddressMessage: boolean;
  inputElementRef: React.MutableRefObject<any>;
  animatePlaceholder: string;
  isFilledAddressValid: boolean;
  label: string;
  autoFocus: boolean;
  minCharToFetch?: number;
  paddingRight?: string;
  required?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

export default function AddressSearchAutocompleteInput({
  typedAddress,
  setTypedAddress,
  handleAddressSelection,
  handleAddressInputFormControlError,
  hasErrorAddressMessage,
  isFilledAddressValid,
  label,
  autoFocus = false,
  minCharToFetch = 5,
  paddingRight,
  required = false,
  onBlur
}: AddressSearchAutocompleteInputProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const timeoutId = setTimeout(
      () =>
        fetchSuggestions(
          typedAddress,
          isFilledAddressValid,
          setSuggestions,
          setIsLoading,
          handleAddressInputFormControlError,
          minCharToFetch
        ),
      400
    );
    return () => clearTimeout(timeoutId);
  }, [typedAddress]);

  return (
    <>
      <div>
        <div
          className={`inputStyle ${hasErrorAddressMessage && 'border-red'
            }`}
        >
          <Input
            type='text'
            id='inputAddress'
            fullWidth
            value={typedAddress}
            label={label}
            onChange={(e) =>
              handleTypedAdress(e.target.value, setTypedAddress, setSuggestions)
            }
            onBlur={onBlur}
            autoFocus={autoFocus}
            required={required}
            error={hasErrorAddressMessage}
          />
        </div>
        <div
          className='autocomplete-dropdown-container'
          style={{ position: 'absolute', zIndex: 5000, width: '100%', paddingRight }}
        >
          {isLoading && <Spinner />}
          {suggestions?.map((suggestion: AutocompleteSuggestionType) => {
            const className = suggestion?.active
              ? 'suggestion-item--active p-2'
              : 'suggestion-item p-2';
            const style = suggestion?.active
              ? {
                backgroundColor: '#fafafa',
                cursor: 'pointer',
                color: BLACK,
                width: '100%',
              }
              : {
                backgroundColor: '#ffffff',
                cursor: 'pointer',
                color: BLACK,
                width: '100%',
              };
            return (
              <div
                key={suggestion.placeId}
                className={className}
                style={style}
                onClick={() =>
                  handleSelectSuggestion(suggestion, handleAddressSelection)
                }
              >
                <strong className='no-localization'>
                  {suggestion?.formattedSuggestion?.mainText}
                </strong>{' '}
                <small className='no-localization'>
                  {suggestion?.formattedSuggestion?.secondaryText}
                </small>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
